import { AxiosInstance } from 'axios';
import { IBaseService, BaseService } from './BaseServiceClass';
import { APIResponseHandler } from 'utilities/ErrorHelper';
import { Invite } from 'types/models/Invite';
import { ISendInvite } from 'stores/InviteStore';

export interface IInviteService extends IBaseService<Invite> {
  sendInvite(content: ISendInvite): Promise<any>;
}

const baseUrl: string = 'api/invitations';

export class InviteService extends BaseService<Invite> implements IInviteService {
  constructor(axiosInstance: AxiosInstance) {
    super(axiosInstance, baseUrl);
  }

  sendInvite = async (content: ISendInvite): Promise<any> => {
    const response = await this._axiosInstance.post(`${baseUrl}`, content);
    return APIResponseHandler(response);
  };
}
